export class Rubro {
  id: number;
  name: string;
  code: string;
}
